<div class="hero-bg hero-bg-cluster-engineering">
  <app-navbar/>
  <div class="d-flex flex-column justify-content-center hero-header">
    <div class="app-container">
      <h1 class="new-line">{{ 'About cluster engineering' }}</h1>
    </div>
  </div>
</div>
